import type { TOC } from '@ember/component/template-only';

interface GeneralTablesCellsTdWithCustomClassSignature {
  Args: {
    cellData: {
      customClass: string;
      formattedValue: string;
    };
  };
}

const GeneralTablesCellsTdWithCustomClass = <template>
  <span class="{{@cellData.customClass}} text-200--regular">
    {{@cellData.formattedValue}}
  </span>
</template> satisfies TOC<GeneralTablesCellsTdWithCustomClassSignature>;

export default GeneralTablesCellsTdWithCustomClass;
